exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wxshop-box .el-switch.is-disabled .el-switch__core {\n  border-color: #13ce66 !important;\n  background-color: #13ce66 !important;\n}\n.resource-dialog .el-table__row {\n  cursor: pointer;\n}\n.resource-dialog .el-table__empty-text {\n  left: 50%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-680c0605","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/view/base/shop/wxshop.vue
// module id = 1553
// module chunks = 0